import * as actions from './actions';
import { List } from 'immutable';
import { Record } from '../transit';

const SearchInformation = Record({
  formattedSearchTime: '',
  formattedTotalResults: '',
  searchTime: 0,
  totalResults: ''
}, 'searchInformation');

const State = Record({
  results: List(),
  pending: false,
  details: {},
  searchQuery: '',
  searchQueryTranslated: '',
  detectedSourceLanguage: '',
  searchInformation: new SearchInformation(),
  translateResults: true,
  defaultCountry: '',
  defaultLanguage: '',
  availableCountries: null,
  availableLanguages: null,
  searchSource: ''
}, 'search');

const ResultItem = Record({
  displayLink: '',
  htmlSnippet: '',
  htmlTitle: '',
  htmlTitleTranslated: '',
  htmlSnippetTranslated: '',
  link: '',
  title: ''
}, 'repository');

const repositoriesReducer = (state = new State(), action = {}) => {
  switch (action.type) {
    case actions.GOOGLE_SEARCH_START: {
      return state
        .set('details', {})
        .set('pending', true);
    }

    case actions.GOOGLE_SEARCH_SUCCESS: {
      if (!action.payload.success) {
        return state
          .set('results', List())
          .set('details', action.payload.error)
          .set('pending', false);
      }

      const results = action.payload.items && action.payload.items
        .reduce((result, item) => result.push(new ResultItem(item)), List());

      return state
        .set('results', results)
        .set('details', {})
        .set('searchInformation', new SearchInformation(action.payload.searchInformation))
        .set('pending', false);
    }

    case actions.GOOGLE_SEARCH_ERROR: {

      return state
        .set('results', List())
        .set('details', action.payload.error)
        .set('searchInformation', new SearchInformation())
        .set('pending', false);
    }

    case actions.TOGGLE_TRANSLATE_RESULTS: {

      return state
        .set('translateResults', action.payload.val);
    }

    case actions.TRANSLATE_START: {
      return state
        .set('searchQueryTranslated', '')
        .set('detectedSourceLanguage', '');
    }

    case actions.TRANSLATE_SUCCESS: {
      if (!action.payload.success) {
        return state;
      }
      const translation = action.payload.data && action.payload.data.translations;
      const {detectedSourceLanguage, translatedText} = translation[0];

      return state
        .set('searchQueryTranslated', translatedText)
        .set('detectedSourceLanguage', detectedSourceLanguage);
    }

    case actions.INPUT_SEARCH: {
      if ((action.payload.query || '').trim() === (state.get('searchQuery') || '').trim()) {
        return state.set('searchQuery', action.payload.query || '');
      }
      return state
        .set('searchQueryTranslated', '')
        .set('detectedSourceLanguage', '')
        .set('searchQuery', action.payload.query);
    }

    case actions.SELECT_SOURCE: {
      return state.set('searchSource', action.payload);
    }

    case actions.RESET: {
      return new State();
    }

    default:
      return state;
  }
};

export default repositoriesReducer;



// WEBPACK FOOTER //
// ./src/common/search/reducer.js